export const COUNTRY_CODE = '44'
export const GOOGLE_SOCIAL_KEY= '223770758643-ecrfhi1dd5fjou1qi1db63merbj0bgk5.apps.googleusercontent.com'
